export enum ContentType {
  HTML = "html",
  //MARKDOWN = "markdown", // maybe for future use
  TEXT = "plain_text",
}
